module.exports = __webpack_public_path__ + "static/media/CT.9e35c684.png";